import { routeActions } from 'redux-simple-router';
import update from 'react/lib/update';
import { addAlert } from '../../MsgNotify/msgNotifyActions';
import { httpGet, httpPut } from '../../Util/http';
import { isDatesSameDay } from '../../Util/dateTime';

export const GET_ACTIVITIES_REQUEST = 'GET_ACTIVITIES_REQUEST';
export function getActivitiesRequest() {
    return {
        type: GET_ACTIVITIES_REQUEST
    }
}

export const GET_ACTIVITIES_SUCCESS = 'GET_ACTIVITIES_SUCCESS'
export function getActivitiesSuccess(json) {
    return {
        type: GET_ACTIVITIES_SUCCESS,
        activities: json.activities,
        activityOrganizer: json.activityOrganizer,
        project: json.project,
        unread: json.unread
    };
}

export const GET_ACTIVITIES_FAILURE = 'GET_ACTIVITIES_FAILURE'
export function getActivitiesFailure() {
    return {
        type: GET_ACTIVITIES_FAILURE
    };
}

export const SET_DATE = 'SET_DATE'
export function setDate(date) {
    return {
        type: SET_DATE,
        date: date
    };
}

export function attemptGetActivities(projectNumber, isReset, date, registrationDate) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/project/' + projectNumber + '/activity';
    return (dispatch) => {
        if (date) {
            _url += '?date=' + date
        }
        if (!isReset) dispatch(getActivitiesRequest())
        return httpGet(_url)
            .then(response => {
                return response.json();
            })
            .then(json => {
                dispatch(getActivitiesSuccess(json))
                if (date)
                    dispatch(setDate(new Date(date)))
                else
                    dispatch(setDate(new Date()))

                dispatch(attemptGetEmployees(json.project.id, registrationDate))
            })
            .catch((e) => {
                dispatch(routeActions.push('/tilbud'));
                dispatch(addAlert(e.message))
            })
    };
}

export const UPDATE_ACTIVITY_ORGANIZER = 'UPDATE_ACTIVITY_ORGANIZER'
export function updateActivityOrganizer(activityOrganizer) {
    return {
        type: UPDATE_ACTIVITY_ORGANIZER,
        activityOrganizer: activityOrganizer
    };
}

export function onActivityDrop(activityId, columnId, index, oldColumnId, oldIndex, organizer, projectId) {
    var newOrganizer1 = update(organizer, {
        [oldColumnId]: {
            items: {
                $splice: [[oldIndex, 1]]
            }
        }
    });
    var newOrganizer = update(newOrganizer1, {
        [columnId]: {
            items: {
                $splice: [[(index > oldIndex && columnId === oldColumnId) ? index - 1 : index, -1, activityId]]
            }
        }
    });
    return dispatch => {
        dispatch(updateActivityOrganizer(newOrganizer));
        var _url = process.env.REACT_APP_webApiEndPoint + 'api/project/' + projectId + '/organizer';
        return httpPut(_url, { activityOrganizer: newOrganizer })
            .then(() => {
                if (columnId !== oldColumnId) {
                    var _url = process.env.REACT_APP_webApiEndPoint + 'api/activity/' + activityId + '/updatestate';
                    return httpPut(_url, { state: columnId })
                        .then(response => {
                            if (response.status >= 400) {
                                throw new Error(response.statusText);
                            }
                            return;
                        })
                }
            })
            .catch((e) => {
                dispatch(updateActivityOrganizer(organizer));
                dispatch(addAlert(e.message))
            })
    };
}


export const ADD_UNREAD_CHAT_MESSAGE = 'ADD_UNREAD_CHAT_MESSAGE'
export function addUnreadChatMessage(activityId) {
    return {
        type: ADD_UNREAD_CHAT_MESSAGE,
        activityId: activityId
    }
}


export const UPDATE_ACTIVITY = 'UPDATE_ACTIVITY'
export function updateActivity(activityId, registered, today, pool) {
    return {
        type: UPDATE_ACTIVITY,
        activityId: activityId,
        registered: registered,
        today: today,
        pool: pool
    }
}

export const UPDATE_ACTIVITY_REGISTERED = 'UPDATE_ACTIVITY_REGISTERED'
export function updateActivityRegistered(activityId, registered) {
    return {
        type: UPDATE_ACTIVITY_REGISTERED,
        activityId: activityId,
        registered: registered
    }
}


export const GET_EMPLOYEES_REQUEST = 'GET_EMPLOYEES_REQUEST';
export function getEmployeesRequest() {
    return {
        type: GET_EMPLOYEES_REQUEST
    }
}

export const GET_EMPLOYEES_SUCCESS = 'GET_EMPLOYEES_SUCCESS'
export function getEmployeesSuccess(json) {
    let employees = []
    json.employees.forEach((employee) => {
        let newEmployee = { ...employee }
        if (employee.absence) {
            newEmployee.absence.date = new Date(employee.absence.date)
        }
        employees.push(newEmployee);
    })
    return {
        type: GET_EMPLOYEES_SUCCESS,
        employees: employees,
        routine: json.routine
    };
}

export function attemptGetEmployees(projectId, date) {
    var _url = process.env.REACT_APP_webApiEndPoint + 'api/project/' + projectId + '/registerhourssidebar';
    if (date) {
        date = JSON.parse(JSON.stringify(date));
        _url += '?date=' + date
    }
    return dispatch => {
        dispatch(getEmployeesRequest());
        return httpGet(_url)
            .then(response => {
                return response.json();
            })
            .then(json => {
                dispatch(getEmployeesSuccess(json))
                if (!date) {
                    dispatch(setRegistrationDate(new Date()));
                }
            })
    };
}

export const SET_EMPLOYEE_HOURS = 'SET_EMPLOYEE_HOURS'
export const SET_EMPLOYEE_NIGHTHOURS = 'SET_EMPLOYEE_NIGHTHOURS'
export function setEmployeeHours(employeeIndex, hours, isNightHours) {
    return {
        type: isNightHours ? SET_EMPLOYEE_NIGHTHOURS : SET_EMPLOYEE_HOURS,
        employeeIndex: employeeIndex,
        hours: hours
    }
}

export const REMOVE_DROPPED_EMPLOYEE = 'REMOVE_DROPPED_EMPLOYEE'
export function removeDroppedEmployee(employeeId, activityId) {
    return {
        type: REMOVE_DROPPED_EMPLOYEE,
        activityId: activityId,
        employeeId: employeeId
    }
}

export const SET_EMPLOYEE_ABSENCE = 'SET_EMPLOYEE_ABSENCE'
export function setEmployeeAbsenceAction(routine, employeeIndex) {
    return {
        type: SET_EMPLOYEE_ABSENCE,
        absence: {
            date: new Date(new Date().getTime() + (24 * 60 * 60 * 1000)),
            absenceCode: null,
            hours: routine
        },
        employeeIndex: employeeIndex
    }
}


export function setEmployeeAbsence(employeeIndex, routine, activities, employeeId) {
    return dispatch => {
        activities.forEach((activity) => {
            dispatch(removeDroppedEmployee(employeeId, activity.id))
        })
        dispatch(setEmployeeAbsenceAction(routine, employeeIndex))

    }
}


export const REGISTER_HOURS = 'REGISTER_HOURS'
export function registerHours(employeeIndex, activityId, employeeId) {
    return {
        type: REGISTER_HOURS,
        employeeIndex: employeeIndex,
        activityId: activityId,
        employeeId: employeeId
    }
}


export const SET_EMPLOYEE_IS_DRAGGING = 'SET_EMPLOYEE_IS_DRAGGING'
export function setEmployeeIsDragging(employeeId) {
    return {
        type: SET_EMPLOYEE_IS_DRAGGING,
        employeeId: employeeId
    }
}

export function changeRegistrationDate(date) {
    return (dispatch, getState) => {
        if (!isDatesSameDay(getState().activityOverviewReducer.registrationDate, date)) {
            dispatch(setRegistrationDate(date));
            dispatch(attemptGetActivities(getState().activityOverviewReducer.project.number, true, JSON.parse(JSON.stringify(date)), date))
        }
    }
}

export const SET_REGISTRATION_DATE = 'SET_REGISTRATION_DATE'
export function setRegistrationDate(date) {
    return {
        type: SET_REGISTRATION_DATE,
        registrationDate: date
    }
}


export const SAVE_REGISTRATION_REQUEST = 'SAVE_REGISTRATION_REQUEST'
export function saveRegistrationRequest() {
    return {
        type: SAVE_REGISTRATION_REQUEST
    }
}


export const SAVE_REGISTRATION_SUCCESS = 'SAVE_REGISTRATION_SUCCESS'
export function saveRegistrationSuccess() {
    return {
        type: SAVE_REGISTRATION_SUCCESS
    };
}

export const SAVE_REGISTRATION_FAILURE = 'SAVE_REGISTRATION_FAILURE'
export function saveRegistrationFailure() {
    return {
        type: SAVE_REGISTRATION_FAILURE
    };
}

export function attemptSaveRegistration() {

    return (dispatch, getState) => {
        var projectId = getState().activityOverviewReducer.project.id
        var _url = process.env.REACT_APP_webApiEndPoint + 'api/employee/register';
        dispatch(saveRegistrationRequest());

        var sortedEmployees = sortEmployees(getState().activityOverviewReducer.employees, getState().activityOverviewReducer.routine);
        let date = getState().activityOverviewReducer.registrationDate;
        //dispatch action with employees with conflict
        if (sortedEmployees.employeesWithConflict.length) {
            dispatch(addEmployeesWithConflict(sortedEmployees.employeesWithConflict))
        }
        var finalObj = { date: date, projectId: projectId, employees: sortedEmployees.employeesToSave };
        return httpPut(_url, finalObj)
            .then(() => {
                //if there is no confliced employees alert successs
                if (!sortedEmployees.employeesWithConflict.length)
                    dispatch(addAlert("Registreringen er gemt", 'success'))
                dispatch(saveRegistrationSuccess())
            })
            .catch((e) => {
                dispatch(addAlert(e.message))
            })
    };
}

export const ADD_EMPLOYEES_WITH_CONFLICT = 'ADD_EMPLOYEES_WITH_CONFLICT'
export function addEmployeesWithConflict(employeesWithConflict) {
    return {
        type: ADD_EMPLOYEES_WITH_CONFLICT,
        employeesWithConflict: employeesWithConflict
    };
}


function sortEmployees(employees, routine) {

    var sortedEmployees = {
        employeesToSave: [],
        employeesWithConflict: []
    }
    employees.forEach((employee, i) => {

        employee.employeeIndex = i;
        //calculate the sum of hours
        let sumHours = 0;
        if (employee.hours)
            sumHours += employee.hours
        if (employee.nightHours)
            sumHours += employee.nightHours

        //if sum of hours and nightHours is equal or higher than routine add employee
        //and employee only has one activity him to save directly
        if (employee.activities.length === 1 && sumHours >= routine && sumHours !== 0) {

            sortedEmployees.employeesToSave.push({
                id: employee.id,
                activities: [{
                    id: employee.activities[0].id,
                    hours: sumHours
                }],
                hours: employee.hours,
                nightHours: employee.nightHours
            })
        }
        else if (employee.activities.length > 1 && sumHours !== 0) {
            //if sum of hours and nightHours is equal or higher than routine add employee
            //add the sum to the employee in a new object
            let newEmployee = { ...employee, sumHours: sumHours }
            if (sumHours < routine) {
                //if employee doesnt already have absence object, create one --> with tomorrow as init date
                if (!employee.absence) {
                    newEmployee.absence = {
                        date: new Date(new Date().getTime() + (24 * 60 * 60 * 1000)),
                        absenceCode: null,
                        hours: routine - sumHours
                    };
                }
            }
            sortedEmployees.employeesWithConflict.push(newEmployee)
        }
        else if (employee.activities.length === 1 && sumHours < routine && sumHours !== 0) {
            let newEmployee = {
                ...employee,
                sumHours: sumHours,
                activities: [{
                    id: employee.activities[0].id,
                    hours: sumHours
                }]
            }
            //if employee doesnt already have absence object, create one -->  with tomorrow as init date
            if (!employee.absence) {
                newEmployee.absence = {
                    date: new Date(new Date().getTime() + (24 * 60 * 60 * 1000)),
                    absenceCode: null,
                    hours: routine - sumHours
                };
            }
            sortedEmployees.employeesWithConflict.push(newEmployee)
        }
        //if employee has no activities, but has absence
        else if (employee.activities.length === 0 && employee.absence != null) {
            sortedEmployees.employeesWithConflict.push(employee)
        }
    });
    return sortedEmployees;
}





export const GET_EMPLOYEE_SUGGESTIONS_SUCCESS = 'GET_EMPLOYEE_SUGGESTIONS_SUCCESS';
export function getEmployeeSuggestionsSuccess(suggestions) {
    return {
        type: GET_EMPLOYEE_SUGGESTIONS_SUCCESS,
        suggestions: suggestions
    }
}



export function getEmployeeSuggestions(val) {

    var fetchUrl = process.env.REACT_APP_webApiEndPoint + "/api/employee/search?query=" + val
    return (dispatch, getState) => {
        if (!val) {
            dispatch(getEmployeeSuggestionsSuccess([]))
            return;
        }
        return httpGet(fetchUrl)
            .then(response => {
                return response.json();
            })
            .then((json) => {
                var jsonReponse = stripSuggestions(json, getState)
                dispatch(getEmployeeSuggestionsSuccess(jsonReponse))
            })
            .catch((e) => {
                console.log(e);
            })
    };
}

function stripSuggestions(suggestions, getState) {
    var alreadyChosen = getState().activityOverviewReducer.employees;
    var newSuggestions = [];
    suggestions.forEach(function (suggestion) {
        var allowedSugg = true;
        //check if already chosen from suggestions
        alreadyChosen.forEach(function (chosen) {
            if (chosen.id === suggestion.id) allowedSugg = false;
        });
        if (allowedSugg) newSuggestions.push(suggestion);
    })
    return newSuggestions;

}




export const ADD_EMPLOYEE_REQUEST = 'ADD_EMPLOYEE_REQUEST'
export function addEmployeeRequest(employee, index) {
    return {
        type: ADD_EMPLOYEE_REQUEST,
        employee: { ...employee, activities: [] },
        index: index
    }
}


export const ADD_EMPLOYEE_SUCCESS = 'ADD_EMPLOYEE_SUCCESS'
export function addEmployeeSuccess() {
    return {
        type: ADD_EMPLOYEE_SUCCESS
    };
}

export const ADD_EMPLOYEE_FAILURE = 'ADD_EMPLOYEE_FAILURE'
export function addEmployeeFailure() {
    return {
        type: ADD_EMPLOYEE_FAILURE
    };
}

export function attemptAddEmployee(employee) {

    return (dispatch, getState) => {
        var projectId = getState().activityOverviewReducer.project.id
        var _url = process.env.REACT_APP_webApiEndPoint + 'api/project/' + projectId + '/addemployee';
        dispatch(addEmployeeRequest(employee, 0));
        dispatch(getEmployeeSuggestionsSuccess([]))
        return httpPut(_url, { id: employee.id })
            .then(() => {
                dispatch(addEmployeeSuccess())
            })
            .catch(() => {
                dispatch(addEmployeeFailure());
                dispatch(addAlert("Kunne ikke tilføje mearbejderen"))
            })
    };
}


export const SET_DROPPED_EMPLOYEE = 'SET_DROPPED_EMPLOYEE'
export function setDroppedEmployee(activityId, employeeId) {
    return {
        type: SET_DROPPED_EMPLOYEE,
        activityId: activityId,
        employeeId: employeeId
    };
}


export const SAVE_CONFLICTED_EMPLOYEE_REQUEST = 'SAVE_CONFLICTED_EMPLOYEE_REQUEST'
export function saveConflictedEmployeesRequest() {
    return {
        type: SAVE_CONFLICTED_EMPLOYEE_REQUEST
    }
}


export const SAVE_CONFLICTED_EMPLOYEE_SUCCESS = 'SAVE_CONFLICTED_EMPLOYEE_SUCCESS'
export function saveConflictedEmployeesSuccess() {
    return {
        type: SAVE_CONFLICTED_EMPLOYEE_SUCCESS
    };
}

export const SAVE_CONFLICTED_EMPLOYEE_FAILURE = 'SAVE_CONFLICTED_EMPLOYEE_FAILURE'
export function saveConflictedEmployeesFailure() {
    return {
        type: SAVE_CONFLICTED_EMPLOYEE_FAILURE
    };
}

export function attemptSaveConflictedEmployees(employees) {
    return (dispatch, getState) => {
        var projectId = getState().activityOverviewReducer.project.id
        var _url = process.env.REACT_APP_webApiEndPoint + 'api/employee/register';
        let date = getState().activityOverviewReducer.registrationDate;
        var employeesToSave = clearActivitiesWithNoHours(employees, dispatch);
        dispatch(saveConflictedEmployeesRequest());
        var finalObj = { date: date, projectId: projectId, employees: employeesToSave };
        return httpPut(_url, finalObj)
            .then(() => {
                dispatch(addAlert("Registreringen er gemt", 'success'))
                dispatch(saveConflictedEmployeesSuccess())
            })
            .catch((e) => {
                dispatch(saveConflictedEmployeesFailure())
                dispatch(addAlert(e.message))
            })
    };
}
export const UPDATE_EMPLOYEE_ACTIVITIES = 'UPDATE_EMPLOYEE_ACTIVITIES'
export function updateEmployeeActivities(employeeIndex, activities, absence) {
    return {
        type: UPDATE_EMPLOYEE_ACTIVITIES,
        employeeIndex: employeeIndex,
        activities: activities,
        absence: absence
    };
}

function clearActivitiesWithNoHours(employees, dispatch) {
    let result = []
    employees.forEach((employee) => {
        let newEmployee = { ...employee, activities: [] }
        if (employee.activities.length) {
            employee.activities.forEach((activity) => {
                if (activity.hours) {
                    newEmployee.activities.push(activity)
                }
                else {
                    dispatch(removeDroppedEmployee(employee.id, activity.id))
                }
            })
        }
        dispatch(updateEmployeeActivities(employee.employeeIndex, newEmployee.activities, employee.absence))
        result.push(newEmployee);
    });
    return result
}


export const SET_ACTIVITY_IS_DRAGGING = 'SET_ACTIVITY_IS_DRAGGING'
export function setActivityIsDragging(isDragging) {
    return {
        type: SET_ACTIVITY_IS_DRAGGING,
        isDragging: isDragging
    };
}



export const RESET_EMPLOYEES_REQUEST = 'RESET_EMPLOYEES_REQUEST'
export function resetEmployeesRequest() {
    return {
        type: RESET_EMPLOYEES_REQUEST
    }
}


export const RESET_EMPLOYEES_SUCCESS = 'RESET_EMPLOYEES_SUCCESS'
export function resetEmployeesSuccess() {
    return {
        type: RESET_EMPLOYEES_SUCCESS
    };
}

export const RESET_EMPLOYEES_FAILURE = 'RESET_EMPLOYEES_FAILURE'
export function resetEmployeesFailure() {
    return {
        type: RESET_EMPLOYEES_FAILURE
    };
}


export function attemptResetEmployees() {
    return (dispatch, getState) => {
        var projectId = getState().activityOverviewReducer.project.id
        var _url = process.env.REACT_APP_webApiEndPoint + 'api/employee/register';
        let date = getState().activityOverviewReducer.registrationDate;
        var employeesToReset = resetEmployees(getState().activityOverviewReducer.employees, dispatch);
        dispatch(resetEmployeesRequest());
        var finalObj = { date: date, projectId: projectId, employees: employeesToReset };
        return httpPut(_url, finalObj)
            .then(() => {
                dispatch(resetEmployeesSuccess())
            })
            .catch((e) => {
                dispatch(resetEmployeesFailure())
                dispatch(addAlert(e.message))
            })
    };
}

export const UPDATE_EMPLOYEE = 'UPDATE_EMPLOYEE'
export function updateEmployee(employeeIndex, employee) {
    return {
        type: UPDATE_EMPLOYEE,
        employeeIndex: employeeIndex,
        employee: employee
    }
}

export const REMOVE_EMPLOYEE_FROM_PROJECT = 'REMOVE_EMPLOYEE_FROM_PROJECT'
export function rmEmployeeFromProjectSuccess(employeeIndex) {
    return {
        type: REMOVE_EMPLOYEE_FROM_PROJECT,
        employeeIndex: employeeIndex
    }
}

export function rmEmployeeFromProject(employeeIndex, employeeId) {
    return (dispatch, getState) => {
        var employee = getState().activityOverviewReducer.employees[employeeIndex];
        if (employee.absence || employee.activities.length) {
            dispatch(addAlert("Kan ikke fjerne medarbejder der er registreret for"))
            return;
        }
        var projectId = getState().activityOverviewReducer.project.id
        var _url = process.env.REACT_APP_webApiEndPoint + "api/project/" + projectId + "/rmemployee?employeeId=" + employeeId;

        dispatch(rmEmployeeFromProjectSuccess(employeeIndex))
        return httpPut(_url)
            .then(() => { })
            .catch(() => {
                dispatch(addEmployeeRequest(employee, employeeIndex))
                dispatch(addAlert("Der skete en fejl, medarbejderen kunne ikke fjernes."))
            })
    };
}


function resetEmployees(employees, dispatch) {
    let result = []
    employees.forEach((employee, index) => {
        let newEmployee = { ...employee, activities: [], nightHours: 0, hours: 0, absence: null }
        employee.activities.forEach((activity) => {
            dispatch(removeDroppedEmployee(employee.id, activity.id))
        })
        dispatch(updateEmployee(index, newEmployee))
        result.push(newEmployee);
    });
    return result
}


export const MOVE_EMPLOYEE_REQUEST = 'MOVE_EMPLOYEE_REQUEST'
export function moveEmployeeRequest(employees) {
    return {
        type: MOVE_EMPLOYEE_REQUEST,
        employees: employees
    }
}

export const MOVE_EMPLOYEE_SUCCESS = 'MOVE_EMPLOYEE_SUCCESS'
export function moveEmployeeSuccess() {
    return {
        type: MOVE_EMPLOYEE_SUCCESS
    }
}

export const MOVE_EMPLOYEE_FAILURE = 'MOVE_EMPLOYEE_FAILURE'
export function moveEmployeeFailure(employees) {
    return {
        type: MOVE_EMPLOYEE_FAILURE,
        employees: employees
    }
}


export function attemptMoveEmployee(employeeIndex, newIndex) {
    return (dispatch, getState) => {
        let projectId = getState().activityOverviewReducer.project.id
        let _url = process.env.REACT_APP_webApiEndPoint + "api/project/" + projectId + "/employees/sort";
        let employees = getState().activityOverviewReducer.employees;
        let emp = employees[employeeIndex]
        let emp1 = update(employees, {
            $splice: [[employeeIndex, 1]]
        });
        let newEmployees = update(emp1, {
            $splice: [[newIndex > employeeIndex ? newIndex - 1 : newIndex, 0, emp]]
        });
        dispatch(moveEmployeeRequest(newEmployees))
        let payLoad = newEmployees.map(employee => {
            return employee.id
        })
        return httpPut(_url, payLoad)
            .then(() => dispatch(moveEmployeeSuccess()))
            .catch(() => {
                dispatch(moveEmployeeFailure(employees))
                dispatch(addAlert("Der skete en fejl, medarbejderen kunne ikke flyttes"))
            })
    };
}


// WEBPACK FOOTER //
// ./src/App/Project/ActivityOverview/actions.js